// extracted by mini-css-extract-plugin
export var box = "styles-module--box--1xdDc";
export var image = "styles-module--image--3QVFx";
export var titleStyle = "styles-module--titleStyle--1ZyCN";
export var content = "styles-module--content--3X_17";
export var inner = "styles-module--inner--1Qbqw";
export var tagsStyle = "styles-module--tagsStyle--Bpk5f";
export var subtitleStyle = "styles-module--subtitleStyle--1zCnW";
export var dateStyle = "styles-module--dateStyle--3-1R2";
export var timeStyle = "styles-module--timeStyle--3K9Pt";